import kfzComponent from './kfz.vue'

const kfzModal = {
    install(Vue) {
        let $vm;
        if (!$vm) {
            const kfzModalPlugin = Vue.extend(kfzComponent);
            $vm = new kfzModalPlugin({
                el: document.createElement('div')
            });
            document.body.appendChild($vm.$el);
        }
        $vm.show = false;
        let kfz = {
            show() {
                $vm.show = true;
            }
        };
        if (!Vue.$kfzModal) {
            Vue.$kfzModal = kfz;
        }
        Vue.mixin({
            created() {
                this.$kfzModal = Vue.$kfzModal;
            }
        })
    }
};

export default kfzModal;



// WEBPACK FOOTER //
// ./src/components/kfz/index.js